import api from './api';

const USER_CACHE_PREFIX = 'users:';
const TICKET_ASSIGNABLE_CACHE_KEY = `${USER_CACHE_PREFIX}ticket-assignable`;

const userService = {
  getAll: async () => {
    const response = await api.cachedGet('/users', {}, {
      cacheKey: `${USER_CACHE_PREFIX}all`,
      ttlMs: 30 * 1000
    });
    return response.data;
  },

  getAllUsers: async () => {
    const response = await api.cachedGet('/users', {}, {
      cacheKey: `${USER_CACHE_PREFIX}all`,
      ttlMs: 30 * 1000
    });
    return response.data;
  },

  getByRole: async (role) => {
    const response = await api.cachedGet(`/users/role/${role}`, {}, {
      cacheKey: `${USER_CACHE_PREFIX}role:${role}`,
      ttlMs: 2 * 60 * 1000
    });
    return response.data;
  },

  getTicketAssignableUsers: async () => {
    const response = await api.cachedGet('/users/ticket-assignable', {}, {
      cacheKey: TICKET_ASSIGNABLE_CACHE_KEY,
      ttlMs: 5 * 60 * 1000
    });
    return response.data;
  },

  getOnlineUsers: async () => {
    const response = await api.cachedGet('/users/online', {}, {
      cacheKey: `${USER_CACHE_PREFIX}online`,
      ttlMs: 5 * 1000
    });
    return response.data;
  },

  create: async (payload) => {
    const response = await api.post('/users', payload);
    api.invalidateCache(USER_CACHE_PREFIX, 'reports:dashboard');
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/users/${id}`);
    api.invalidateCache(USER_CACHE_PREFIX, 'reports:dashboard', 'tickets:detail:', 'tickets:list:');
    return response.data;
  },
  update: async (id, payload) => {
    const response = await api.put(`/users/${id}`, payload);
    api.invalidateCache(USER_CACHE_PREFIX, 'reports:dashboard', `tickets:detail:`);
    return response.data;
  },

  adminResetPassword: async (id, new_password) => {
    const response = await api.post(`/users/${id}/reset-password`, { new_password });
    return response.data;
  },
};

export default userService;
